import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DatePipe } from '@angular/common';
import { DateFormatPipe } from '../../pipe/filter.pipe';

@Component({
  selector: 'app-timestamp-cell',
  template: '<div class="date" title="{{ value | dateFormat }}">{{ value | date: format }}</div>',
  imports: [DatePipe, DateFormatPipe],
})
export class TimestampCellComponent {
  @Input() value: Date | number | string;

  format: string;

  constructor(translation: TranslateService) {
    this.format = translation.instant('DateFormat');
  }
}
